<ngx-spinner class="custom-spinner" bdColor="rgba(255,255,255,1)" size="medium" color="#fff" type="ball-atom"
    [fullScreen]="true">
    <span class="loader">
        <img src="/assets/media/logos/logo-wegestu-color.png" alt="">
    </span>
</ngx-spinner>
<div id="kt_app_toolbar" class="app-toolbar py-3 py-lg-6">
    <!--begin::Toolbar container-->
    <div id="kt_app_toolbar_container" class="app-container container-fluid d-flex flex-stack">
        <!--begin::Page title-->
        <div class="page-title d-flex flex-column justify-content-center flex-wrap me-3">
            <!--begin::Title-->
            <div class="d-flex align-items-center">
                <h1 class="page-heading">
                    <svg xmlns="http://www.w3.org/2000/svg" width="29" height="28" viewBox="0 0 29 28" fill="none">
                        <g filter="url(#filter0_d_1938_1605)">
                            <path
                                d="M23.7844 8.77288C23.7311 8.08623 23.1655 7.54858 22.4809 7.52592C21.5601 7.49571 20.6795 6.9972 20.1992 6.13546C19.7128 5.27165 19.7422 4.25541 20.1904 3.44653C20.5299 2.83335 20.3345 2.06637 19.7641 1.66056C19.318 1.34332 18.8432 1.06386 18.3445 0.826275C17.7105 0.524149 16.9468 0.730144 16.5813 1.33165C16.1017 2.12061 15.2382 2.64727 14.2483 2.64727C13.2585 2.64727 12.3956 2.12061 11.9154 1.33165C11.5492 0.729457 10.7861 0.523462 10.1522 0.826275C9.65349 1.06386 9.17939 1.34332 8.73261 1.66056C8.16218 2.06637 7.9668 2.83267 8.30632 3.44653C8.75447 4.25609 8.78384 5.27234 8.29744 6.13546C7.81719 6.9972 6.93661 7.49502 6.01573 7.52592C5.33122 7.54858 4.76557 8.08623 4.71229 8.77288C4.69316 9.01733 4.68359 9.26452 4.68359 9.51378C4.68359 9.76303 4.69316 10.0102 4.71229 10.2547C4.76557 10.9413 5.33122 11.479 6.01573 11.5016C6.93661 11.5318 7.81719 12.0297 8.29744 12.8921C8.78384 13.7559 8.75447 14.7721 8.30632 15.581C7.9668 16.1942 8.16218 16.9612 8.73261 17.367C9.1787 17.6842 9.65349 17.9637 10.1522 18.2013C10.7861 18.5034 11.5492 18.2974 11.9154 17.6959C12.395 16.9069 13.2585 16.3803 14.2483 16.3803C15.2382 16.3803 16.101 16.9063 16.5813 17.6959C16.9475 18.2981 17.7105 18.5041 18.3445 18.2013C18.8432 17.9637 19.318 17.6842 19.7641 17.367C20.3345 16.9612 20.5299 16.1949 20.1904 15.581C19.7422 14.7715 19.7128 13.7552 20.1992 12.8921C20.6795 12.0304 21.5601 11.5325 22.4809 11.5016C23.1655 11.479 23.7311 10.9413 23.7844 10.2547C23.8035 10.0102 23.8131 9.76303 23.8131 9.51378C23.8131 9.26452 23.8035 9.01733 23.7844 8.77288ZM14.249 12.947C12.3629 12.947 10.8333 11.4096 10.8333 9.51378C10.8333 7.61793 12.3629 6.08052 14.249 6.08052C16.1352 6.08052 17.6648 7.61793 17.6648 9.51378C17.6648 11.4096 16.1352 12.947 14.249 12.947Z"
                                fill="#265D91" />
                            <path
                                d="M10.7591 19.0264C10.4571 19.0264 10.1497 18.9598 9.85935 18.8218C9.32991 18.5691 8.81824 18.2684 8.33798 17.9271C7.47312 17.3126 7.20328 16.161 7.70881 15.2471C8.05994 14.614 8.05721 13.8594 7.70266 13.2297C7.35152 12.6001 6.71346 12.2114 5.99342 12.1874C4.95436 12.1531 4.11135 11.3449 4.03074 10.308C4.01093 10.045 4 9.78 4 9.51289C4 9.24578 4.01093 8.98142 4.03074 8.71912C4.11135 7.68091 4.95504 6.87341 5.99274 6.83839C6.71346 6.81504 7.35152 6.4264 7.70129 5.7988C8.05721 5.16639 8.05926 4.41245 7.70881 3.77936C7.20328 2.86543 7.47312 1.71323 8.33798 1.09936C8.81755 0.758097 9.32923 0.457344 9.85867 0.205343C10.8192 -0.251966 11.9539 0.0776265 12.4977 0.973705C12.8734 1.59169 13.5272 1.96042 14.2479 1.96042C14.9686 1.96042 15.6224 1.59169 15.9981 0.973019C16.5426 0.0776265 17.6793 -0.251966 18.6364 0.204657C19.1659 0.457344 19.6775 0.758097 20.1578 1.09936C21.0227 1.71391 21.2925 2.86543 20.787 3.77936C20.4358 4.41245 20.4386 5.16708 20.7931 5.79674C21.1443 6.4264 21.7823 6.81504 22.5024 6.83907C23.5414 6.87341 24.3844 7.68159 24.465 8.71844C24.4848 8.98142 24.4958 9.24647 24.4958 9.51358C24.4958 9.78069 24.4848 10.045 24.465 10.3073C24.3844 11.3456 23.5407 12.1531 22.503 12.1881C21.7823 12.2114 21.1443 12.6001 20.7945 13.2277C20.4386 13.8601 20.4365 14.614 20.787 15.2471C21.2925 16.161 21.0227 17.3132 20.1578 17.9271C19.6782 18.2684 19.1665 18.5691 18.6371 18.8211C17.6746 19.2791 16.5419 18.9482 15.9974 18.0534C15.6224 17.4348 14.9686 17.066 14.2479 17.066C13.5272 17.066 12.8734 17.4348 12.4984 18.0528C12.1185 18.6762 11.4531 19.0264 10.7591 19.0264ZM10.7591 1.37402C10.6539 1.37402 10.5459 1.39737 10.4434 1.44612C9.98574 1.66448 9.54237 1.9254 9.12634 2.22066C8.83258 2.4294 8.73694 2.81256 8.90295 3.11194C9.48704 4.16663 9.48294 5.4232 8.89133 6.47378C8.31612 7.50581 7.22241 8.17324 6.03714 8.21169C5.70172 8.22268 5.4189 8.49253 5.39294 8.82624C5.37586 9.05284 5.36629 9.28218 5.36629 9.51358C5.36629 9.74498 5.37586 9.97501 5.39294 10.2023C5.4189 10.5346 5.70172 10.8045 6.03783 10.8155C7.22172 10.8546 8.31612 11.5213 8.8927 12.5561C9.48226 13.6033 9.48704 14.8598 8.90295 15.9152C8.73694 16.2146 8.83258 16.5978 9.12634 16.8065C9.54169 17.1018 9.98573 17.3627 10.4441 17.581C10.7714 17.7376 11.1539 17.6318 11.3322 17.3373C11.9573 16.308 13.0469 15.6934 14.2479 15.6934C15.4489 15.6934 16.5385 16.3087 17.1636 17.338C17.3425 17.6325 17.7237 17.7362 18.0523 17.581C18.51 17.3627 18.9534 17.1018 19.3694 16.8065C19.6632 16.5978 19.7588 16.2146 19.5928 15.9152C19.0087 14.8605 19.0128 13.604 19.6044 12.5534C20.1797 11.5213 21.2734 10.8539 22.4586 10.8155C22.7941 10.8045 23.0769 10.5346 23.1028 10.2009C23.1199 9.97432 23.1295 9.74498 23.1295 9.51358C23.1295 9.28218 23.1199 9.05215 23.1028 8.82487C23.0769 8.49253 22.7941 8.22268 22.458 8.21169C21.2741 8.17255 20.1797 7.50581 19.6031 6.47103C19.0135 5.42389 19.0087 4.16732 19.5928 3.11194C19.7588 2.81256 19.6632 2.4294 19.3694 2.22066C18.9541 1.9254 18.51 1.66448 18.0517 1.44612C17.7244 1.29025 17.3425 1.39531 17.1642 1.6892C16.5385 2.71917 15.4482 3.33372 14.2479 3.33372C13.0476 3.33372 11.9573 2.71917 11.3315 1.6892C11.2086 1.48663 10.99 1.37402 10.7591 1.37402Z"
                                fill="#265D91" />
                        </g>
                        <defs>
                            <filter id="filter0_d_1938_1605" x="0" y="0" width="28.4961" height="27.0264"
                                filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
                                <feFlood flood-opacity="0" result="BackgroundImageFix" />
                                <feColorMatrix in="SourceAlpha" type="matrix"
                                    values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
                                <feOffset dy="4" />
                                <feGaussianBlur stdDeviation="2" />
                                <feComposite in2="hardAlpha" operator="out" />
                                <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0" />
                                <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_1938_1605" />
                                <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_1938_1605"
                                    result="shape" />
                            </filter>
                        </defs>
                    </svg>
                    Paramètres
                </h1>
                <!--begin::Menu-->
            </div>
            <!--end::Title-->
            <!--begin::Breadcrumb-->
            <ul class="breadcrumb breadcrumb-separatorless fw-semibold fs-7 my-0 pt-1">
                <!--begin::Item-->
                <li class="breadcrumb-item text-muted">
                    <a class="text-muted" routerLink="/">Accueil</a>
                </li>
                <!--end::Item-->
                <!--begin::Item-->
                <li class="breadcrumb-item">
                    <span class="bullet bg-gray-400 w-5px h-2px"></span>
                </li>
                <!--end::Item-->
                <!--begin::Item-->
                <li class="breadcrumb-item text-muted">Paramètres</li>
                <li class="breadcrumb-item">
                    <span class="bullet bg-gray-400 w-5px h-2px"></span>
                </li>
                <li class="breadcrumb-item text-muted">Évaluation</li>
                <li class="breadcrumb-item">
                    <span class="bullet bg-gray-400 w-5px h-2px"></span>
                </li>
                <!--end::Item-->
                <!--begin::Item-->
                <li class="breadcrumb-item text-muted">Évaluation par défaut</li>

                <!--end::Item-->
                <!--begin::Item-->

                <!--end::Item-->
            </ul>
        </div>
        <!--end::Page title-->
        <!--begin::Actions-->

        <!--end::Actions-->
    </div>
    <!--end::Toolbar container-->
</div>

<div id="kt_app_content" class="app-content flex-column-fluid mb-4">
    <!--begin::Content container-->
    <div id="kt_app_content_container" class="app-container container-fluid mb-15">
        <div class="card">
            <div class="card-body " [formGroup]="searchForm">
                <div class="title">
                    <h4>Recherche</h4>
                </div>
                <div class="filtrage mt-5">
                    <div class="row">
                        <div class="col-lg-3">
                            <div class=" me-md-2 mb-3">
                                <input type="text" formControlName="name" class="form-control form-control-solid ps-5"
                                    name="société" placeholder="Nom entreprise" />
                            </div>
                        </div>

                        <div class="col-lg-3">
                            <div class=" me-md-2 mb-3">
                                <ng-select [items]="typesEvaluation" bindLabel="name" formControlName="typeEval"
                                    bindValue="id" [placeholder]="'Type'" [notFoundText]="'Aucun élément trouvé'"
                                    autoComplete>
                                </ng-select>
                            </div>
                        </div>

                        <div class="col-lg-3 mt-2">
                            <div class=" me-md-2 mb-3 calenderDate">
                                <p-calendar [style]="{'border': 'none','margin-top': '-6px'}" dateFormat="dd/mm/yy"
                                    placeholder="Date de début de la publication" inputId="yearpicker"
                                    formControlName="eval_date"></p-calendar>

                            </div>
                        </div>
                    </div>
                    <div class="mb-3 search-btn d-flex justify-content-end">
                        <div class="align-items-center recherche">
                            <button type="submit" class="me-5" (click)="getListEvaluation()">
                                <svg width="15" height="15" viewBox="0 0 20 20" fill="none"
                                    xmlns="http://www.w3.org/2000/svg">
                                    <path
                                        d="M19.7235 18.263L16.0223 14.5657C18.8541 11.0421 18.5809 5.83122 15.3515 2.63023C13.6625 0.942973 11.4019 0 8.9923 0C6.58271 0 4.34709 0.942973 2.63307 2.63023C0.943993 4.31749 0 6.5756 0 8.98259C0 11.3895 0.943993 13.6228 2.63307 15.3349C4.32216 17.0222 6.58271 17.9652 8.9923 17.9652C11.0293 17.9652 13.0165 17.2704 14.6063 16.005L18.3076 19.7023C18.5064 19.9008 18.7547 20 19.0032 20C19.2764 20 19.5249 19.9008 19.6987 19.7023C20.0962 19.2805 20.0962 18.6601 19.7235 18.2631L19.7235 18.263ZM15.9973 8.95782C15.9973 10.8189 15.2771 12.5807 13.9603 13.8958C12.6438 15.2109 10.88 15.9306 9.01701 15.9306C7.154 15.9306 5.39017 15.2111 4.0737 13.8958C2.75714 12.5806 2.03667 10.8188 2.03667 8.95782C2.03667 7.09682 2.75697 5.3349 4.0737 4.01985C5.39026 2.70472 7.154 1.98502 9.01701 1.98502C10.88 1.98502 12.6438 2.70454 13.9603 4.01985C15.2771 5.33499 15.9973 7.09682 15.9973 8.95782Z"
                                        fill="white" />
                                </svg>
                                Rechercher
                            </button>
                        </div>

                        <div class="resett-btn">
                            <div class="reset-icon cursor-pointer">
                                <a (click)="reset()">
                                    <img src="/assets/media/icons/icon-reset.png" alt="" width="30px">
                                </a>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div id="kt_app_content" class="app-content flex-column-fluid mb-4">
        <div id="kt_app_content_container" class="app-container container-fluid">
            <div class="card pb-10 pt-10">

                <!--begin::Card header-->
                <div class="card-body d-flex flex-wrap my-1 header-grid">
                    <div class="title mb-5">
                        <h4>
                            Évaluation par défaut
                        </h4>
                    </div>
                    <div class="button-add mb-5">
                        <a class="btn-add cursor-pointer" (click)="openModal(add_updat_evaluation,'create')">Ajouter une
                            évaluation</a>
                    </div>
                </div>

                <!--end::Card header-->
                <!--begin::Card body-->
                <div class="card-body pt-0">
                    <div class="content">
                        <div class="card-body pt-3">
                            <!--begin::Table-->
                            <div class="table-responsive">
                                <table class="table align-middle fs-6 gy-5 style-table" id="kt_customers_table">
                                    <thead>
                                        <tr class="text-start text-gray-400 fw-bold fs-7 text-uppercase gs-0">
                                            <th class="min-w-125px"><span>Évaluation</span></th>
                                            <th class="min-w-125px"><span>DATE DE CRéATION</span></th>
                                            <th class="min-w-125px"><span>type</span> </th>
                                            <th class="min-w-90px"><span>Actions</span></th>
                                        </tr>
                                    </thead>
                                    <tbody class="fw-semibold text-gray-600">
                                        <tr *ngFor="let evaluation of listEvaluation; let i=index">
                                            <td>
                                                <a class="eval ">{{evaluation?.name?evaluation.name:'---'}}</a>
                                            </td>

                                            <td>
                                                <span>{{!evaluation?.created_at?'---':evaluation.created_at |
                                                    formatDate}}</span>
                                            </td>
                                            <td><span class=" remote">{{evaluation.type}}</span></td>
                                            <td>
                                                <div class="tools">
                                                    <div class="dropdown">
                                                        <button mat-button [matMenuTriggerFor]="menu"
                                                            class="btn btn-sm btn-light btn-flex btn-center btn-active-light-primary dropdown-toggle"
                                                            type="button" id="dropdownMenuButton"
                                                            data-bs-toggle="dropdown" aria-haspopup="true"
                                                            aria-expanded="false">
                                                            <svg width="19" height="5" viewBox="0 0 19 5" fill="none"
                                                                xmlns="http://www.w3.org/2000/svg">
                                                                <circle cx="2.44739" cy="2.44739" r="2.44739"
                                                                    transform="matrix(1 0 0 -1 0 4.89478)"
                                                                    fill="#265D91" />
                                                                <circle cx="2.44739" cy="2.44739" r="2.44739"
                                                                    transform="matrix(1 0 0 -1 6.85254 4.89478)"
                                                                    fill="#265D91" />
                                                                <circle cx="2.44739" cy="2.44739" r="2.44739"
                                                                    transform="matrix(1 0 0 -1 13.7061 4.89478)"
                                                                    fill="#265D91" />
                                                            </svg>
                                                        </button>
                                                        <mat-menu #menu="matMenu">
                                                            <button mat-menu-item (click)="navigateToListQuestions(evaluation.id)">
                                                                Consulter questions
                                                            </button>
                                                            <button mat-menu-item (click)="openModal(add_updat_evaluation,'update',evaluation)">
                                                                Modifier
                                                            </button>
                                                            <button mat-menu-item (click)="openDeleteAlert(evaluation)">
                                                                Supprimer
                                                            </button>
                                                          </mat-menu>
                                                    </div>
                                                </div>
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                            <div class="pagination" *ngIf="listEvaluation && listEvaluation.length">
                                <mat-paginator [length]="totalElements" [pageSize]="pageSize"
                                    [showFirstLastButtons]="true" [pageSizeOptions]="pageSizeOptions"
                                    [pageIndex]="currentPage" (page)="onPageChange($event)" aria-label="Select page">
                                </mat-paginator>
                            </div>
                            <div class="alert alert-warning text-center mt-5" role="alert"
                                *ngIf="listEvaluation && !listEvaluation.length">
                                <img src="/assets/media/logos/logo-no-data.png" alt="" class="mb-5" />
                                <span class="empty-list"> La liste est vide </span>
                            </div>
                            <!--end::Table-->
                        </div>

                    </div>
                    <!--end::Table-->
                </div>
                <!--end::Card body-->
            </div>
        </div>
    </div>
    <!--begin::Card-->

    <!--end::Card-->
    <!--begin::Modals-->
    <!--begin::Modal - Customers - Add-->

    <div class="modal fade" id="add-eval" tabindex="-1" aria-hidden="true">
        <!--begin::Modal dialog-->
        <!--begin::Modal content-->
        <div class="modal-dialog modal-dialog-centered">
            <div class="modal-content">
                <!--begin::Modal header-->
                <div class="modal-header">
                    <!--begin::Modal title-->
                    <h2 class="title"> Ajouter question</h2>
                    <!-- {{mode=='create'?'Ajouter':'Modifier'}} -->
                    <!--end::Modal title-->
                    <!--begin::Close-->
                    <div id="kt_customers_export_close" data-bs-dismiss="modal"
                        class="btn btn-icon btn-sm btn-active-icon-primary">
                        <i class="ki-duotone ki-cross fs-1">
                            <span class="path1"></span>
                            <span class="path2"></span>
                        </i>
                    </div>
                </div>
                <div class="modal-body mx-5">
                    <div class="bloc-input mb-5">
                        <label for="nom" class="mb-2">Ajouter question</label>
                        <input type="text" name="question" id="question" class="form-control mb-3">
                    </div>

                    <div class="choose mb-5">
                        <span>Type de réponse</span>
                        <div class="form-check form-check-custom form-check-solid">
                            <input class="form-check-input" type="radio" value="1" id="noteRadio" />
                            <label class="form-check-label" for="noteRadio">
                                Note / 5
                            </label>
                        </div>

                        <div class="form-check form-check-custom form-check-solid">
                            <input class="form-check-input" type="radio" value="2" id="commentRadio1" />
                            <label class="form-check-label" for="commentRadio1">
                                Commentaire
                            </label>
                        </div>
                    </div>
                </div>
                <div class="card-footer mx-5">
                    <div class="actions">
                        <a href="#" class="annuler" data-bs-dismiss="modal" aria-label="Close">Annuler</a>
                        <a class="confirmer">Confirmer</a>
                    </div>
                </div>
                <!--end::Modal body-->
            </div>
        </div>
        <!--end::Modal content-->
        <!--end::Modal dialog-->
    </div>
    <ng-template #add_updat_evaluation>
        <div class="modal-content" id="modifier" tabindex="-1">
            <!--begin::Modal dialog-->
            <!--begin::Modal content-->
            <div class="">
                <div class="">
                    <!--begin::Modal header-->
                    <div class="modal-header">
                        <!--begin::Modal title-->
                        <h2 class="title"> {{mode=='create'?'Ajouter une évaluation':'Modifier l\'évaluation'}} </h2>
                        <!--end::Modal title-->
                        <!--begin::Close-->
                        <div id="kt_customers_export_close" data-bs-dismiss="modal"
                            class="btn btn-icon btn-sm btn-active-icon-primary">
                            <i class="ki-duotone ki-cross fs-1" (click)="closeModal()">
                                <span class="path1"></span>
                                <span class="path2"></span>
                            </i>
                        </div>
                    </div>
                    <div class="modal-body mx-5" [formGroup]="evaluationForm">
                        <div class="bloc-input mb-5">
                            <label for="nom" class="required mb-2">Nom</label>
                            <input formControlName="name" type="text" name="question" id="question" placeholder="Nom"
                                class="form-control mb-3">
                            <app-feild-error [control]="evaluationForm.get('name')"></app-feild-error>
                        </div>
                        <div class="mb-5">
                            <div class="bloc-input mb-10">
                                <label for="type" class="required mb-2">Type</label>
                                <!-- <ng-select [items]="typesEvaluation" bindLabel="name" formControlName="type" 
                                        bindValue="id" [placeholder]="'Type'" [notFoundText]="'Aucun élément trouvé'"
                                            autoComplete>
                                        </ng-select> -->


                                <ng-select [items]="typesEvaluation" bindLabel="name" formControlName="type"
                                    bindValue="id" [placeholder]="'Type'" [notFoundText]="'Aucun élément trouvé'"
                                    autoComplete>
                                </ng-select>
                                <app-feild-error [control]="evaluationForm.get('type')"></app-feild-error>
                            </div>
                        </div>
                        <div class="checkbox-container">
                            <input type="checkbox" id="checkboxType" class="checkbox-btn"
                                formControlName="checkboxGestion" (change)="onCheckboxChange($event)" />
                            <label for="checkboxType">Gestion des questions</label>
                        </div>
                    </div>
                    <div class="card-footer mx-5">
                        <div class="actions">
                            <a (click)="closeModal()" class="annuler cursor-pointer" data-bs-dismiss="modal"
                                aria-label="Close">Annuler</a>
                            <button class="confirmer cursor-pointer" [disabled]="!evaluationForm.valid"
                                (click)="submitData()">Confirmer</button>
                        </div>
                    </div>
                    <!--end::Modal body-->
                </div>
            </div>

            <!--end::Modal content-->
            <!--end::Modal dialog-->
        </div>
    </ng-template>

    <!--end::Modal - Customers - Add-->
    <!--begin::Modal - Adjust Balance-->

    <!--end::Modal - New Card-->
    <!--end::Modals-->

    <!--end::Content container-->
</div>